import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import { Testing } from './Testing';
import { TestingAudio } from './TestingAudio';

function App() {

  useEffect(() => {

    TestingAudio.Init();
  }, []);


  



  return (
    <div className="App">      
      <p>
        Testing
      </p>

      <video id="sbvideo" src="" autoPlay loop/>
      <button id="myBtn">Join test</button>

      <div id="container">

      </div>
       
    </div>
  );
}

export default App;
